import { render } from "./paymentPage.vue?vue&type=template&id=6f73bb44&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"

import "./paymentPage.vue?vue&type=style&index=0&id=6f73bb44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f73bb44"]])

export default __exports__